import dayjs from "dayjs";

const EMPTY = "—";

const isNum = (value: unknown): value is number =>
  typeof value === "number" && Number.isFinite(value);

export const formatPodCount = (value: number | null | undefined): string => {
  if (!isNum(value)) return EMPTY;
  return value.toLocaleString("en-IN");
};

export const formatPodMoney = (value: number | null | undefined): string => {
  if (!isNum(value)) return EMPTY;
  return value.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  });
};

export const formatPodDate = (value: string | null | undefined): string => {
  if (!value) return EMPTY;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format("D MMM YYYY") : value;
};

export const formatPodDateTime = (value: string | null | undefined): string => {
  if (!value) return EMPTY;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format("D MMM YYYY, HH:mm") : value;
};

export const formatPodShare = (
  part: number | null | undefined,
  total: number | null | undefined,
): string => {
  if (!isNum(part) || !isNum(total) || total <= 0) return EMPTY;
  return `${Math.round((part / total) * 100)}%`;
};
